function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAnswer3 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 122 122",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M102.324,101.205c-23.259,23.914 -61.025,24.963 -84.283,2.342c-23.259,-22.622 -23.259,-60.402 -0,-84.316c23.258,-23.913 61.024,-24.963 84.283,-2.341c23.258,22.621 23.258,60.402 -0,84.315Z",
    style: {
      fill: "#b0de4b"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M121.713,60.857l-4.25,-0c-0.001,15.638 -6.333,29.776 -16.58,40.027c-10.25,10.247 -24.388,16.578 -40.027,16.579c-15.638,-0.001 -29.776,-6.332 -40.027,-16.579c-10.247,-10.251 -16.578,-24.389 -16.579,-40.027c0.001,-15.638 6.332,-29.777 16.579,-40.027c10.251,-10.247 24.389,-16.579 40.027,-16.58c15.639,0.001 29.777,6.333 40.027,16.58c10.247,10.25 16.579,24.388 16.58,40.027l4.25,-0c-0.001,-33.611 -27.245,-60.855 -60.857,-60.857c-33.611,0.002 -60.855,27.246 -60.856,60.857c0.001,33.611 27.245,60.855 60.856,60.856c33.612,-0.001 60.856,-27.245 60.857,-60.856Z",
    style: {
      fill: "#272525",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.199,47.187c0,-2.865 2.323,-5.188 5.188,-5.188c2.865,0 5.188,2.323 5.188,5.188c0,2.865 -2.323,5.188 -5.188,5.188c-2.865,0 -5.188,-2.323 -5.188,-5.188Z",
    style: {
      fill: "#272525",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.139,47.187c0,-2.865 2.322,-5.188 5.187,-5.188c2.865,0 5.188,2.323 5.188,5.188c0,2.865 -2.323,5.188 -5.188,5.188c-2.865,0 -5.187,-2.323 -5.187,-5.188Z",
    style: {
      fill: "#272525",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.404,70.055c-1.956,6.293 -5.874,11.731 -11.037,15.593c-5.166,3.862 -11.561,6.145 -18.511,6.146c-6.949,-0.001 -13.344,-2.284 -18.51,-6.146c-5.164,-3.862 -9.081,-9.3 -11.037,-15.593c-0.349,-1.121 -1.54,-1.747 -2.66,-1.398c-1.121,0.348 -1.747,1.539 -1.398,2.66c2.229,7.167 6.681,13.345 12.55,17.735c5.867,4.39 13.167,6.993 21.055,6.992c7.888,0.001 15.189,-2.602 21.056,-6.992c5.869,-4.39 10.321,-10.568 12.551,-17.735c0.348,-1.121 -0.278,-2.312 -1.399,-2.66c-1.12,-0.349 -2.311,0.277 -2.66,1.398Z",
    style: {
      fill: "#272525",
      fillRule: "nonzero"
    }
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAnswer3);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/answer-3.58515e403fbc0b6bd91ea47c90de3861.svg";